/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `hrv` message.
 *
 * Heart rate variability
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class HrvMesg : Mesg {
    public constructor() : super("Hrv", Profile.MesgNum.HRV)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** Number of values stored in time. */
    public val numTime: Int
        get() = getField(TIME_FIELD_NUM)?.numValues ?: 0

    /** time, in s. Time between beats */
    public var time: List<Double?>?
        get() {
            val field = getField(TIME_FIELD_NUM) ?: return null
            return List(field.numValues) { getTime(it) }
        }
        set(value) {
            removeField(TIME_FIELD_NUM)
            value?.forEachIndexed { index, element -> setTime(index, element) }
        }

    public fun getTime(index: Int): Double? =
        getFieldValue(TIME_FIELD_NUM, index) as? Double

    public fun setTime(index: Int, value: Double?) {
        setFieldValue(TIME_FIELD_NUM, value, index)
    }

    public companion object {
        public const val TIME_FIELD_NUM: UByte = 0u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("Time", 0u, BaseType.UINT16, 1000.0, 0.0, "s", false)
            return fields
        }
    }
}
